import dayjs from "dayjs"
import { useQueryGet } from "../../typed-client/hooks/use-query-get"
import { version } from "./-version.json"

export function VersionInfoCard() {
  const { data } = useQueryGet("/api/version", null)
  return (
    <div
      style={{
        background: "lightdark(var(--mantine-color-body, #fff))",
        padding: 24,
        maxWidth: 420,
        boxShadow: "0 1px 4px 0 rgba(0,0,0,0.03)",
        color: "lightdark(var(--mantine-color-dark-7), #222)",
        fontFamily: "var(--mantine-font-family, sans-serif)",
      }}
    >
      <div style={{ fontSize: 18, fontWeight: 600, marginBottom: 16 }}>
        Version Information
      </div>
      <div
        style={{
          display: "grid",
          gridTemplateColumns: "max-content 1fr",
          rowGap: 6,
          columnGap: 12,
          alignItems: "center",
        }}
      >
        <div style={{ fontWeight: 500 }}>Client version:</div>
        <div>{version}</div>
        <div style={{ fontWeight: 500 }}>Server version:</div>
        <div>{data?.buildNumber}</div>
        <div style={{ fontWeight: 500 }}>Build date:</div>
        <div>{data?.buildTime ? dayjs(data.buildTime).format("L") : null}</div>
      </div>
    </div>
  )
}
